<template>
  <div class="wrapper">
      <div class="head">反馈意见</div>
      <div class="textarea">
          <el-input
                  type="textarea"
                  :rows="16"
                  v-model="feedback">
          </el-input>
          <div class="send-btn" @click="send">发送</div>
      </div>
      
  </div>
</template>

<script>
import gql from 'graphql-tag'
export default {
    name: '',
    data() {
        return {
            feedback: ''
        }
    },
    methods: {
        async send() {
            if (this.feedback !== '') {
                let res = await this.$apollo.mutate({
                    mutation: gql`mutation ($content: String!) {
                    doctorFeedback(content: $content)
                }`,
                    variables: {
                        content: this.feedback
                    }
                });
                if (res.data) {
                    this.$router.replace({name: 'Result', params: {success: 'true'}})
                } else {
                    this.$router.replace('/home/user/result')
                }
            } else {
                this.$message('内容不能为空');
            }
        }
    }
}
</script>

<style lang="less" scoped>
    .wrapper{
        width: 100%;
        height: 100%;
        .head{
            height: 40px;
            padding-left: 5px;
            color: #49a2c2;
            border-bottom: 1px solid #49a2c2;
            font-size: 14px;
            line-height: 40px;
            font-weight: bold;
        }
        .textarea{
            padding: 20px 5px 5px;
            .send-btn{
                width: 80px;
                height: 28px;
                color: #fff;
                border-radius: 5px;
                margin: 10px auto 0;
                background-color: #49a2c2;
                font-size: 12px;
                text-align: center;
                line-height: 28px;
                cursor: pointer;
                user-select: none;
            }
        }
    }
</style>
